import { Grid, Hidden, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import ExaminationInfoCardVertical from "shared/learning/components/ExaminationInfoCardVertical/ExaminationInfoCardVertical"
import AvailableExamsSkeletonGroup from "./components/AvailableExamsSkeletonGroup"
import moment from "moment"

const AvailableExams = ({ myExamsResult }) => {
  const { t } = useTranslation()

  const courseDetails = t("learning.details.course", { returnObjects: true })

  return (
    <>
      <Hidden lgDown>
        <Typography pb={3} variant="h1">
          {t("learning.admin.overview.header", "Available courses")}
        </Typography>
      </Hidden>
      <Grid container spacing={2}>
        {myExamsResult.status === 2 ? (
          myExamsResult.data
            .filter((item) => {
              const completedRaw = item.examinationCertificate?.completedDate

              const startRaw = item.recertificationStartDate
              const endRaw = item.recertificationEndDate
              const isRecertActive = item.recertificationIsActive
              const hasPassed = item.examinationSummary?.hasPassed
              const hasExpired = item.examinationSummary?.hasExpired

              const completedOutsideRecertWindow =
                isRecertActive &&
                completedRaw &&
                startRaw &&
                endRaw &&
                moment(completedRaw).isValid() &&
                moment(startRaw).isValid() &&
                moment(endRaw).isValid() &&
                !moment(completedRaw).isBetween(moment(startRaw), moment(endRaw), "day", "[]")

              const shouldRender =
                hasExpired || (isRecertActive && !hasPassed) || completedOutsideRecertWindow

              return shouldRender
            })
            .map((item, i) => {
              const assignedCourses =
                Array.isArray(courseDetails) &&
                courseDetails.find((course) => course.examinationType === item.examinationType)

              return (
                <Grid item xs={12} md={6} xl={4} key={i} style={{ borderRadius: "16px !important" }}>
                  <ExaminationInfoCardVertical assignedCourses={assignedCourses} item={item} />
                </Grid>
              )
            })
        ) : (
          <AvailableExamsSkeletonGroup />
        )}
      </Grid>
    </>
  )
}

export default AvailableExams
